import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

const SKIP_ROUTES = ['/api/auth/login', '/api/auth/register', '/api/auth/token/refresh'];

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const isSkipped = SKIP_ROUTES.some(route => req.url.includes(route));

  const addToken = (request: typeof req) => {
    const token = auth.getToken();
    if (!token || isSkipped) return request;
    return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  };

  return next(addToken(req)).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !isSkipped && auth.getRefreshToken()) {
        return auth.refreshToken().pipe(
          switchMap(() => next(addToken(req))),
          catchError(refreshErr => {
            auth.logout();
            return throwError(() => refreshErr);
          }),
        );
      }
      return throwError(() => err);
    }),
  );
};
